export enum MoverRole {
    Transferee = 'transferee',
    Leaver = 'leaver',
}
